import ValibotCommon from '@shared-schemas/common'
import geojson_schemas from '@shared-schemas/geojson'
import * as v from 'valibot'

export const geospatialDataGroupRecordSchema = v.object({
	id: ValibotCommon.getUuidSchema({ expect_short_uuid: true, error_message: 'id is not a valid short UUID' }),
	customer_id: ValibotCommon.getUuidSchema({
		expect_short_uuid: true,
		error_message: 'customer_id is not a valid short UUID',
	}),
	user_id: ValibotCommon.getUuidSchema({ expect_short_uuid: true, error_message: 'user_id is not a valid short UUID' }),
	user_display_name: v.pipe(v.string(), v.trim()),
	uploaded_file_id: v.optional(
		v.nullable(
			ValibotCommon.getUuidSchema({
				expect_short_uuid: true,
				error_message: 'uploaded_file_id is not a valid short UUID',
			}),
		),
	),
	uploaded_file: v.object({
		original_filename: v.nullable(v.pipe(v.string(), v.trim())),
		file_format: v.nullable(v.pipe(v.string(), v.trim())),
		file_size_bytes: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(0))),
	}),
	display_name: v.pipe(v.string(), v.trim()),
	num_zones: v.pipe(v.number(), v.integer(), v.minValue(0)),
	is_deleted: v.boolean(),
	created_at: v.pipe(v.string(), v.isoTimestamp()),
	updated_at: v.pipe(v.string(), v.isoTimestamp()),

	// NOTE: not part of the table structure; created dynamically if the user_id is null
	is_default_record: v.optional(v.boolean()),

	// NOTE: not part of the table structure; created dynamically from the associated geospatial_data records
	gps: v.optional(geojson_schemas.feature_collection),
})

export const filterValuesUsersSchema = v.object({
	user_id: ValibotCommon.getUuidSchema({
		expect_short_uuid: true,
		error_message: 'user_id is not a valid short UUID',
	}),
	display_name: v.pipe(v.string(), v.trim()),
})

export const filterValuesSchema = v.object({
	users: v.array(filterValuesUsersSchema),
})
